import Vue from 'vue'
import embedSlideApi from '@/api/embed-slide'

const _state = {
  embedSlides: {},
  loading: false,
  error: null,
  embedSrcError: null,
}

const _getters = {
  activeEmbedSlide: (state, _, rootState) => {
    const { activeSlideId } = rootState
    return {
      ...rootState.slideActive,
      ...state.embedSlides[activeSlideId],
    }
  },
  embedSrcError: (state) => state.embedSrcError,
  embedPlatform: (_, getters) => {
    const embedSrc = getters.activeEmbedSlide?.attributes?.embedSrc

    if (!embedSrc) return null

    if (embedSrc.includes('youtube.com') || embedSrc.includes('youtu.be')) {
      return 'youtube'
    }
    if (embedSrc.includes('docs.google.com/presentation')) {
      return 'googleSlides'
    }
    if (embedSrc.includes('miro.com')) {
      return 'miro'
    }
    if (embedSrc.includes('skoletube.dk')) {
      return 'skoletube'
    }
    return 'other'
  },
}

const actions = {
  async loadEmbedSlideAction({ commit }, { slideId }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_EMBED_SRC_ERROR', null)
      const response = await embedSlideApi.getEmbedSlide(slideId)
      commit('SET_CURRENT_EMBED_SLIDE', response.body)
      return response.body
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateEmbedSlideAction({ commit, getters }, {
    slideId, attributes,
  }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_EMBED_SRC_ERROR', null)
      const updatedAttributes = {
        ...getters.activeEmbedSlide?.attributes,
        ...attributes,
      }

      // Optimistically update the state
      const optimisticSlide = {
        slideId,
        attributes: updatedAttributes,
      }
      commit('SET_CURRENT_EMBED_SLIDE', optimisticSlide)

      const response = await embedSlideApi.updateEmbedSlide(slideId, updatedAttributes)
      commit('SET_CURRENT_EMBED_SLIDE', response.body)
      return response.body
    } catch (resp) {
      if (resp?.body?.errors?.embedSrc) {
        commit('SET_EMBED_SRC_ERROR', resp?.body?.errors?.embedSrc)
      }
      throw resp
    } finally {
      commit('SET_LOADING', false)
    }
  },

  setEmbedSrcErrorAction({ commit }, error) {
    commit('SET_EMBED_SRC_ERROR', error)
  },
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_EMBED_SRC_ERROR(state, error) {
    state.embedSrcError = error
  },

  SET_CURRENT_EMBED_SLIDE(state, slide) {
    if (slide && slide.slideId) {
      Vue.set(state.embedSlides, slide.slideId, slide)
    }
  },

  REMOVE_EMBED_SLIDE(state, slideId) {
    const { [slideId]: removed, ...remaining } = state.embedSlides
    state.embedSlides = remaining
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
